// src/redux/reportconfigSlice.js

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
  get_reportconfig,
  add_reportconfig,
  update_reportconfig,
  delete_reportconfig,
  get_reportconfig_list,
  get_studentreport_genrate,
} from '../Service/ApiServices.js';
import { toast } from 'react-toastify';

const initialState = {
  reportconfig: [],
  studentreportconfig: [],
  reportconfiglist:[],
   studenttotalPages: 0,
  studentpageSize: 10,
  studentcount: 0,
  studentactivePage: 1,
  studentloading: false,
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
    report_key:"",
    title:"",
    filters:"",
    fields:"",
  },
};

export const fetchstudentreportconfig = createAsyncThunk(
  "reportconfig/fetchstudentreportconfig",
  async ({ page, page_size,school_id,formData, token, signal }, { rejectWithValue }) => {

    try {
      const response = await get_studentreport_genrate(page, page_size,school_id,formData,token, signal);

        
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


// Async Thunks for API Calls
export const fetchreportconfiglist = createAsyncThunk(
    'reportconfig/fetchreportconfiglist',
    async ({school_id,token, signal }, { rejectWithValue }) => {
      try {
        const response = await get_reportconfig_list(school_id,token, signal);
        if (response.status) {
          return response.response;
        } else {
          return rejectWithValue(response.response.message);
        }
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );
  // Async Thunks for API Calls


// Async Thunks for API Calls
export const fetchreportconfig = createAsyncThunk(
  "reportconfig/fetchreportconfig",
  async ({ page, page_size,school_id,report_key, token, signal }, { rejectWithValue }) => {

    try {
      const response = await get_reportconfig(page, page_size,school_id,report_key,token, signal);

        
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);



export const createreportconfig = createAsyncThunk(
  "reportconfig/createreportconfig",
  async ({ data,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_reportconfig(data,school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updatereportconfig = createAsyncThunk(
  "reportconfig/updatereportconfig",
  async ({ data, token, school_id,signal }, { rejectWithValue }) => {
    try {
      const response = await update_reportconfig(data, token,school_id, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deletereportconfig = createAsyncThunk(
  "reportconfig/deletereportconfig",
  async ({ ids, token,school_id, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_reportconfig({ ids }, token,school_id, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// reportconfig Slice
const reportconfigSlice = createSlice({
  name: 'reportconfigs',
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
      setStudentActivePage(state, action) {
      state.studentactivePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    EditFormData(state, action) {
      const { id, title,bank_name,account_no,ifsc,balance} = action.payload;
      state.formData = { id, title,bank_name,account_no,ifsc,balance};
    },
    resetFormData(state) {
    state.formData = {
    title:"",
    bank_name:"",
    account_no:"",
    ifsc:"",
    balance:0,
      };
    },
    setreportconfig(state, action) {
      state.reportconfig = action.payload;
    },
      setstudentreportconfig(state, action) {
      state.studentreportconfig = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
      setstudentPageSize(state, action) {
      state.studentpageSize = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
    .addCase(fetchreportconfiglist.fulfilled, (state, action) => {
        state.reportconfiglist = action.payload.data;
      })
      .addCase(fetchreportconfiglist.rejected, (state, action) => {
        state.reportconfiglist = [];
      })
      .addCase(fetchstudentreportconfig.pending, (state) => {
        state.studentloading = true;
      })
      .addCase(fetchstudentreportconfig.fulfilled, (state, action) => {
        state.studentloading = false;
        state.studentreportconfig = action.payload.results;
        state.studentcount = action.payload.count;
        state.studenttotalPages = Math.ceil(action.payload.count / state.studentpageSize);
      })
      .addCase(fetchstudentreportconfig.rejected, (state, action) => {
        state.studentloading = false;
        state.studentreportconfig = [];
        state.error = action.payload;
      })
       // Fetch reportconfig
       .addCase(fetchreportconfig.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchreportconfig.fulfilled, (state, action) => {
        state.loading = false;
        state.reportconfig = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchreportconfig.rejected, (state, action) => {
        state.loading = false;
        state.reportconfig = [];
        state.error = action.payload;
      })

      // Add reportconfig
      .addCase(createreportconfig.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createreportconfig.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createreportconfig.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage);  
        state.IsEditing = false;
      })
      // Update reportconfig
      .addCase(updatereportconfig.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updatereportconfig.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updatereportconfig.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        state.IsEditing = false;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage); 
      })
      // Delete reportconfig
      .addCase(deletereportconfig.pending, (state) => {
        state.loading = true;
      })
      .addCase(deletereportconfig.fulfilled, (state, action) => {
        state.loading = false;
        console.log(action.payload);
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deletereportconfig.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {   setreportconfig,
  setActivePage,
  setstudentreportconfig,
  setStudentActivePage,
  setstudentPageSize,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setPageSize } = reportconfigSlice.actions;
export default reportconfigSlice.reducer;
